import { Grid } from "@mui/material";
import { FormattedMessage } from "react-intl";
import { useClipboard } from "use-clipboard-copy";
import { useAccount } from "wagmi";

import { Breadcrumbs, PageHeader } from "@dzambalaorg/mui-page-layout";
import { Button } from "@dzambalaorg/ui-kit";

import { StyledTextField } from "./styled";

export const ReferralCabinet = () => {
  const { address: account = "" } = useAccount();
  const clipboard = useClipboard();

  const refLink = `${process.env.MARKET_FE_URL}/?referrer=${account.toLowerCase()}`;

  // useEffect(() => {
  //   if (!isActive) {
  //     void openConnectWalletDialog();
  //   } else {
  //     void closeConnectWalletDialog();
  //   }
  // }, [isActive]);

  return (
    <Grid>
      <Breadcrumbs path={["dashboard", "referral", "referral.cabinet"]} />

      <PageHeader message="pages.referral.cabinet.title" />

      <StyledTextField value={`${refLink}`} variant="standard" inputRef={clipboard.target} />
      <Button onClick={clipboard.copy}>
        <FormattedMessage id="form.buttons.copy" />
      </Button>
    </Grid>
  );
};
